// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"realTime_wrapper__LDYYt","checkbox":"realTime_checkbox__Tio4E"};